import { Component, OnInit, Input } from '@angular/core';
import { CrudService, Search, Page, MessageService, Attach, AttachService, download } from 'elbuild-ui-lib-core';
import { Deliverable, Project } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliverableEditComponent } from '../deliverable-edit/deliverable-edit.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DeliverableAttachmentsComponent } from '../deliverable-attachments/deliverable-attachments.component';
import { DialogService } from 'elbuild-ui-componentslib';


@Component({
	selector: 'app-deliverable-list',
	templateUrl: './deliverable-list.component.html',
	styleUrls: ['./deliverable-list.component.scss']
})
export class DeliverableListComponent implements OnInit {

	@Input()
	activityid: number;

	@Input()
	projectid: number;
	project: Project;

	deliverables: Deliverable[] = [];
	loading: boolean = true;

	@Input()
	usercompanyid: number;


	constructor(private crudService: CrudService<Deliverable>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private dialogService: DialogService,
		private attachService: AttachService,
		private dom: DomSanitizer,
		private projectService: CrudService<Project>) { }

	ngOnInit() {

		this.load();


		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}
	}


	load() {
		this.loading = true;
		const search = new Search('deliverable');
		search.addSimpleFilter('activityid', this.activityid);
		this.crudService.searchEntities(Deliverable, 'deliverable', search, new Page(100)).subscribe(data => {
			this.deliverables = data;
			this.loading = false;
		}, error => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	download(row: Attach) {
		this.attachService.download(row.id, 'download').subscribe(response => {
			if (response) download(response, row.filename);
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.attach'));
		});
	}



	dochistory(del: Deliverable) {
		const modal = this.modalService.open(DeliverableAttachmentsComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.deliverableid = del.id;
	}



	edit(del?: Deliverable) {
		const modal = this.modalService.open(DeliverableEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.activityid = this.activityid;
		modal.componentInstance.companyid = this.project?.companyid;

		if (del && del.id) {
			modal.componentInstance.load(del.id);
			modal.componentInstance.attach = del.attach;
		}
		modal.result.then((newItem: Deliverable) => {
			this.load();
		}).catch(() => { });
	}


	delete(row: Deliverable) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-deliverable-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.crudService.deleteEntity(Deliverable, 'deliverable', row).subscribe(() => {
					this.translateService.get(['labels.deliverable-deleted', 'labels.deliverable']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.deliverable-deleted'], messages['labels.deliverable']);
						this.load();
					});
				});
			}
		});
	}

}
